var map = {
	"./page-01.jpg": "7246",
	"./page-02.jpg": "3607",
	"./page-03.jpg": "9475",
	"./page-04.jpg": "c97c",
	"./page-05.jpg": "32d1",
	"./page-06.jpg": "8e4f",
	"./page-07.jpg": "f34a",
	"./page-08.jpg": "a243",
	"./page-09.jpg": "74a7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "db1b";